/* ==========================================================================
   RESILIENT HUSTLE — mockup interaction layer
   Ports to: assets/rh-cart-drawer.js + assets/rh-pdp.js  (Phase 3/4)

   This file is THROWAWAY, but its SHAPE is not. The Liquid port replaces the
   fake setTimeout calls with real fetch('/cart/add.js') and keeps every other
   line. Cart state below mirrors /cart.js's response shape exactly so the
   port is a fetch swap, not a state-machine rewrite.

   Every line operation is keyed on `key` (Shopify's stable "<variant_id>:<hash>"),
   NEVER on a 1-based line index. With S-3XL across 214 variants, two sizes of
   one product is an ordinary cart — which is the exact shape that makes
   index-keyed mutations remove the wrong line (recurring bug B-011).
   ========================================================================== */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

  /* Width params must not assume a '?' already exists — a raw concat produces
     image.jpg&width=800, which the CDN will not resolve. */
  function atWidth(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?width=' : '&width=') + w;
  }

  /* ---------------------------------------------------------------- toast */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'rh-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.setAttribute('data-show', 'true');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.setAttribute('data-show', 'false'); }, 2600);
  }

  /* ======================================================= cart (REAL Shopify)
     This replaces the mockup's simulated cart. The mockup faked adds with
     setTimeout and invented a line key of `variantId + ":" + size`; Shopify's
     real key is `variantId:<hash>` (e.g. 48113988534423:4499c536c3...). A theme
     shipping the fake version LOOKS like it works — the drawer fills, the count
     goes up — while the actual cart stays empty and checkout has nothing in it.

     Every mutation keys on Shopify's own `item.key`, never a line index. */
  var cart = { items: [], total_price: 0, item_count: 0 };
  var pending = {};

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function shipThreshold() {
    var el = $('[data-rh-ship-msg]');
    var v = el && el.getAttribute('data-rh-threshold');
    return v ? parseInt(v, 10) : 0;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function renderCart(c) {
    if (c) cart = c;

    $$('[data-rh-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    var list = $('[data-rh-lines]');
    if (!list) return;

    if (!cart.items || !cart.items.length) {
      list.innerHTML =
        '<li class="rh-empty"><p class="rh-mono">Your bag is empty</p>' +
        '<p style="margin-top:16px"><a class="rh-btn rh-btn--ghost" href="' +
        esc(list.getAttribute('data-rh-shop-url') || '/collections/all') +
        '">Shop the drop</a></p></li>';
    } else {
      list.innerHTML = cart.items.map(function (it) {
        var img = it.image ? atWidth(it.image, 200) : '';
        var opts = (it.variant_title || '').replace('Default Title', '');
        /* Server truth for anything money-shaped — only say FREE when the cart says so. */
        var price = it.final_line_price === 0 ? 'FREE' : money(it.final_line_price);
        return '' +
          '<li class="rh-line' + (pending[it.key] ? ' is-loading' : '') + '" data-cart-line="' + esc(it.key) + '">' +
            '<div class="rh-line__media">' +
              (img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '" width="72" height="90" loading="lazy">' : '') +
            '</div>' +
            '<div>' +
              '<p class="rh-line__title">' + esc(it.product_title) + '</p>' +
              '<p class="rh-line__meta">' + esc(opts) + '</p>' +
              '<div class="rh-line__row">' +
                '<div class="rh-qty">' +
                  '<button type="button" data-rh-qty="-1" aria-label="Decrease quantity for ' + esc(it.product_title) + '">–</button>' +
                  '<span>' + it.quantity + '</span>' +
                  '<button type="button" data-rh-qty="1" aria-label="Increase quantity for ' + esc(it.product_title) + '">+</button>' +
                '</div>' +
                '<span class="rh-line__price">' + price + '</span>' +
              '</div>' +
              '<button type="button" class="rh-line__remove" data-rh-remove>Remove</button>' +
            '</div>' +
          '</li>';
      }).join('');
    }

    var total = $('[data-rh-total]');
    if (total) total.textContent = money(cart.total_price);
    var foot = $('[data-rh-foot]');
    if (foot) foot.hidden = !cart.item_count;

    var threshold = shipThreshold();
    if (threshold > 0) {
      var remain = Math.max(0, threshold - cart.total_price);
      var msg = $('[data-rh-ship-msg]');
      var fill = $('[data-rh-ship-fill]');
      if (msg) {
        msg.innerHTML = remain === 0
          ? 'Free US shipping unlocked'
          : '<b>' + money(remain) + '</b> away from free US shipping';
      }
      if (fill) fill.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    }

    /* Hide the upsell once its product is in the bag — offering someone the thing
       they just added reads as broken. The server filtered on first paint; this
       keeps it honest after a client-side add. */
    var up = $('[data-rh-upsell-id]');
    if (up) {
      var upId = up.getAttribute('data-rh-upsell-id');
      /* Only hide what is already in the bag. Tying visibility to item_count as
         well meant a stale/failed cart read could hide a perfectly good upsell —
         the server already decided whether to render it at all. */
      var owned = (cart.items || []).some(function (it) { return String(it.product_id) === upId; });
      if (cart.items && cart.items.length) up.hidden = owned;
    }
  }

  /* Surface Shopify's OWN message. A generic "try again" hides the one thing the
     shopper needs to know — e.g. "Only 1 item was added to your cart due to
     availability", which is a stock limit, not a failure they can retry away. */
  function toastFrom(res) {
    return res.json().then(function (j) {
      toast(j.description || j.message || 'Could not update your bag');
    }).catch(function () { toast('Could not update your bag'); });
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
      .then(function (r) {
        if (!r.ok) return toastFrom(r).then(function () { throw new Error('add rejected'); });
        return getCart().then(function (c) { renderCart(c); openDrawer(); });
      })
      .catch(function (e) { if (e.message !== 'add rejected') toast('Could not update your bag'); });
  }

  function changeLine(key, qty) {
    pending[key] = true;
    renderCart();
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })      // key, never a line index
    })
      .then(function (r) {
        if (!r.ok) {
          /* Rejected (usually stock). Tell them why, then RESYNC from the server —
             never leave the optimistic quantity showing a number the cart refused. */
          return toastFrom(r).then(function () { return getCart(); }).then(function (c) {
            delete pending[key];
            renderCart(c);
          });
        }
        return r.json().then(function (c) {
          delete pending[key];   // clear BEFORE the paint that reads it, or the line
          renderCart(c);         // paints greyed-and-dead with nothing to repaint it
        });
      })
      .catch(function () {
        delete pending[key];
        toast('Could not update your bag');
        return getCart().then(renderCart);
      });
  }

  /* ---------------------------------------------------------------- drawer */
  var lastFocus = null;

  function openDrawer() {
    var d = $('[data-rh-drawer]'), s = $('[data-rh-scrim]');
    if (!d) return;
    lastFocus = document.activeElement;
    s.hidden = false;
    d.setAttribute('data-open', 'true');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = $('[data-rh-drawer-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    var d = $('[data-rh-drawer]'), s = $('[data-rh-scrim]');
    if (!d) return;
    d.setAttribute('data-open', 'false');
    d.setAttribute('aria-hidden', 'true');
    s.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  /* ----------------------------------------------------------------- modal */
  function openModal(id) {
    var m = document.getElementById(id);
    if (!m) return;
    lastFocus = document.activeElement;
    m.hidden = false;
    document.body.style.overflow = 'hidden';
    var c = m.querySelector('[data-rh-modal-close]');
    if (c) c.focus();
  }

  function closeModal(m) {
    m.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  /* -------------------------------------------------------------- gallery */
  function swapGallery(btn) {
    var full = btn.getAttribute('data-rh-full');
    var main = $('[data-rh-gallery-main]');
    if (!main || !full) return;
    main.src = atWidth(full, 1200);
    main.alt = btn.getAttribute('data-rh-alt') || main.alt;
    $$('[data-rh-thumb]').forEach(function (t) { t.setAttribute('aria-pressed', String(t === btn)); });
  }

  /* ---------------------------------------- single delegated click handler */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var scrollTo = t.closest('[data-rh-scroll]');
    if (scrollTo) {
      var sel = scrollTo.getAttribute('data-rh-scroll');
      var dest = $(sel);
      if (dest) {
        e.preventDefault();
        dest.scrollIntoView({ behavior: 'smooth', block: 'start' });
        closeMobileNav();
      }
      return;
    }

    if (t.closest('[data-rh-cart-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-rh-drawer-close]') || t.closest('[data-rh-scrim]')) { e.preventDefault(); closeDrawer(); return; }

    var menuBtn = t.closest('[data-rh-menu]');
    if (menuBtn) {
      e.preventDefault();
      var nav = $('[data-rh-mobnav]');
      var open = nav.getAttribute('data-open') !== 'true';
      nav.setAttribute('data-open', String(open));
      menuBtn.setAttribute('aria-expanded', String(open));
      return;
    }

    var openM = t.closest('[data-rh-modal-open]');
    if (openM) { e.preventDefault(); openModal(openM.getAttribute('data-rh-modal-open')); return; }

    var closeM = t.closest('[data-rh-modal-close]');
    if (closeM) { e.preventDefault(); closeModal(closeM.closest('.rh-modal')); return; }
    if (t.classList && t.classList.contains('rh-modal')) { closeModal(t); return; }

    var thumb = t.closest('[data-rh-thumb]');
    if (thumb) { e.preventDefault(); swapGallery(thumb); return; }

    var qtyBtn = t.closest('[data-rh-qty]');
    if (qtyBtn) {
      var lineEl = qtyBtn.closest('[data-cart-line]');
      var k = lineEl.getAttribute('data-cart-line');
      var delta = parseInt(qtyBtn.getAttribute('data-rh-qty'), 10);
      var cur = 0;
      (cart.items || []).forEach(function (it) { if (it.key === k) cur = it.quantity; });
      changeLine(k, cur + delta);
      return;
    }

    var rm = t.closest('[data-rh-remove]');
    if (rm) { changeLine(rm.closest('[data-cart-line]').getAttribute('data-cart-line'), 0); return; }

    var up = t.closest('[data-rh-upsell-add]');
    if (up) { e.preventDefault(); addToCart(up.getAttribute('data-rh-variant'), 1); return; }

    /* Anything still pointing at "#" is a Phase-3 stub. Swallow it and say so —
       never silently scroll the page to the top mid-review. */
    var a = t.closest('a[href="#"], [data-rh-stub]');
    if (a) {
      e.preventDefault();
      toast(a.getAttribute('data-rh-stub') || 'Phase 3 link — wires up at Liquid port');
    }
  });

  function closeMobileNav() {
    var nav = $('[data-rh-mobnav]');
    if (nav) nav.setAttribute('data-open', 'false');
    var b = $('[data-rh-menu]');
    if (b) b.setAttribute('aria-expanded', 'false');
  }

  /* ------------------------------------------------------------- ATC form */
  document.addEventListener('submit', function (e) {
    /* Match the mockup's attribute form AND the theme's class form. Liquid
       argument keys cannot contain hyphens, so the theme's {% form %} tag can
       only carry id/class — the data-* hooks sit on a wrapper instead. */
    var form = e.target.closest('[data-rh-atc-form], form.rh-atc-form');
    if (form) {
      /* The form is a REAL <form action="/cart/add" method="post">. In the
         mockup we intercept; if this JS fails in production the browser still
         posts to Shopify and the buyer still adds to cart. */
      e.preventDefault();
      var sizeInputs = form.querySelectorAll('input[data-rh-opt]');
      if (sizeInputs.length && !form.querySelector('input[data-rh-opt]:checked')) {
        toast('Choose a size first'); return;
      }
      /* Resolve across ALL options — with Color x Size, "Large" alone is
         ambiguous and would add the wrong colourway. */
      var v = form.querySelector('[data-rh-variants]')
        ? matchVariant(form)
        : null;
      var id = v ? v.id : (form.querySelector('input[name="id"]') || {}).value;
      if (!id) { toast('That combination is unavailable'); return; }
      addToCart(id, 1);
      return;
    }

    var email = e.target.closest('[data-rh-email-form]');
    if (email) {
      e.preventDefault();
      var msg = email.querySelector('[data-rh-formmsg]');
      var val = email.querySelector('input[type="email"]').value.trim();
      if (!val) { if (msg) msg.textContent = 'Enter an email address'; return; }
      if (msg) msg.textContent = 'You are on the list.';
      email.reset();
    }
  });

  /* ------------------------------------------------- variant resolution ----
     A variant is the intersection of ALL options, not just Size. Reading the
     size radio alone worked while every product had one real option; six
     products carry Color x Size, where "Large" is two different variants.

     Option ORDER varies (Newspaper Shirts is Size x Color, the rest Color x
     Size), so selections are gathered by data-rh-opt INDEX and compared against
     variant.opts positionally. */
  function variantsOf(form) {
    var tag = form.querySelector('[data-rh-variants]');
    if (!tag) return null;
    if (!tag._rh) { try { tag._rh = JSON.parse(tag.textContent); } catch (err) { return null; } }
    return tag._rh;
  }

  function chosenOpts(form) {
    var out = [];
    form.querySelectorAll('input[data-rh-opt]:checked').forEach(function (r) {
      out[parseInt(r.getAttribute('data-rh-opt'), 10)] = r.value;
    });
    return out;
  }

  function matchVariant(form) {
    var vs = variantsOf(form), sel = chosenOpts(form);
    if (!vs) return null;
    for (var i = 0; i < vs.length; i++) {
      var ok = true;
      for (var j = 0; j < sel.length; j++) {
        if (sel[j] !== undefined && vs[i].opts[j] !== sel[j]) { ok = false; break; }
      }
      if (ok) return vs[i];
    }
    return null;
  }

  /* Grey out sizes that do not exist in the chosen colour, so the buyer learns
     the combination is gone BEFORE submitting rather than from an error toast. */
  function syncAvailability(form) {
    var vs = variantsOf(form), sel = chosenOpts(form);
    if (!vs) return;
    form.querySelectorAll('input[data-rh-opt]').forEach(function (r) {
      var pos = parseInt(r.getAttribute('data-rh-opt'), 10);
      var live = vs.some(function (v) {
        if (v.opts[pos] !== r.value || !v.available) return false;
        for (var j = 0; j < sel.length; j++) {
          if (j !== pos && sel[j] !== undefined && v.opts[j] !== sel[j]) return false;
        }
        return true;
      });
      r.disabled = !live;
    });
  }

  function syncVariant(form) {
    var v = matchVariant(form);
    syncAvailability(form);
    var hidden = form.querySelector('input[name="id"]');
    var btn = form.querySelector('.rh-atc button[type="submit"]');
    form.querySelectorAll('[data-rh-optlabel]').forEach(function (el) {
      var sel = chosenOpts(form)[parseInt(el.getAttribute('data-rh-optlabel'), 10)];
      if (sel) el.textContent = sel;
    });
    if (!v) {
      if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
      return null;
    }
    if (hidden) hidden.value = v.id;
    var price = form.querySelector('[data-rh-price-out]');
    if (price) price.textContent = money(v.price);

    /* Stock line: real counts only. Shown at 3 or fewer, and only when Shopify
       is tracking the variant — an untracked variant reports qty 0 and would
       otherwise read as "sold out" on a product that is perfectly buyable. */
    var stock = form.querySelector('[data-rh-stock]');
    if (stock) {
      if (v.track && v.available && v.qty > 0 && v.qty <= 3) {
        stock.textContent = v.qty === 1 ? 'Last one in this size' : 'Only ' + v.qty + ' left in this size';
        stock.hidden = false;
      } else {
        stock.hidden = true;
      }
    }
    if (btn) {
      btn.disabled = !v.available;
      btn.innerHTML = v.available
        ? 'Add to bag &mdash; <span>' + money(v.price) + '</span>'
        : 'Sold out';
    }
    /* Colour changes should move the gallery to that colourway. */
    if (v.img) {
      var hero = document.querySelector('[data-rh-gallery] img, .rh-pdp__media img');
      if (hero) { hero.removeAttribute('srcset'); hero.src = v.img; }
    }
    return v;
  }

  document.addEventListener('change', function (e) {
    var radio = e.target.closest('input[data-rh-opt]');
    if (!radio) return;
    var form = radio.closest('[data-rh-atc-form], form.rh-atc-form');
    if (form) syncVariant(form);
  });

  /* Run once on load: the checked-by-default combination may already be sold
     out, and unavailable sizes must be greyed before the first interaction. */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-rh-atc-form], form.rh-atc-form').forEach(function (f) {
      if (f.querySelector('[data-rh-variants]')) syncVariant(f);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openModalEl = $('.rh-modal:not([hidden])');
    if (openModalEl) { closeModal(openModalEl); return; }
    var d = $('[data-rh-drawer]');
    if (d && d.getAttribute('data-open') === 'true') closeDrawer();
  });

  /* ==================================================== collection sorting
     The control is a REAL <form method="get"> with Shopify's own sort_by
     values, so without JS it submits ?sort_by=… and the server sorts — same
     progressive-enhancement shape as the ATC form. JS just avoids the reload. */
  var sortSel = $('[data-rh-sort]');
  var grid = $('[data-rh-collgrid]');
  if (sortSel && grid) {
    var original = Array.prototype.slice.call(grid.children);
    sortSel.addEventListener('change', function () {
      var v = sortSel.value;
      var next = original.slice();
      if (v === 'price-ascending')  next.sort(function (a, b) { return (+a.dataset.price) - (+b.dataset.price); });
      if (v === 'price-descending') next.sort(function (a, b) { return (+b.dataset.price) - (+a.dataset.price); });
      if (v === 'title-ascending')  next.sort(function (a, b) { return a.dataset.title.localeCompare(b.dataset.title); });
      next.forEach(function (el) { grid.appendChild(el); });
    });
    /* Reflect ?sort_by= on load so a no-JS submit and a JS sort agree. */
    var q = new URLSearchParams(location.search).get('sort_by');
    if (q) { sortSel.value = q; sortSel.dispatchEvent(new Event('change')); }
  }

  /* ================================================ sticky add-to-cart (PDP)
     Visible whenever the real ATC button is off screen. IntersectionObserver
     rather than a scroll listener: no scroll-thrash, and it reports the actual
     visibility of the element instead of a guessed offset that breaks the
     moment the gallery height changes. */
  var stickyBar = $('[data-rh-stickyatc]');

  function setSticky(show) {
    if (!stickyBar) return;
    var suppressed = stickyBar.getAttribute('data-suppressed') === 'true';
    var on = show && !suppressed;
    stickyBar.setAttribute('data-show', String(on));
    stickyBar.setAttribute('aria-hidden', String(!on));
    /* A hidden bar must not be reachable by keyboard — a translated-offscreen
       element is still in the tab order without this. */
    var btn = stickyBar.querySelector('button');
    if (btn) btn.tabIndex = on ? 0 : -1;
    document.body.setAttribute('data-stickyatc', String(on));
  }

  function suppressSticky(yes) {
    if (!stickyBar) return;
    stickyBar.setAttribute('data-suppressed', String(yes));
    if (yes) setSticky(false);
    else if (stickyBar.getAttribute('data-atc-offscreen') === 'true') setSticky(true);
  }

  if (stickyBar && 'IntersectionObserver' in window) {
    var anchor = $('.rh-atc');
    if (anchor) {
      new IntersectionObserver(function (entries) {
        var off = !entries[0].isIntersecting;
        stickyBar.setAttribute('data-atc-offscreen', String(off));
        setSticky(off);
      }, { threshold: 0 }).observe(anchor);
    }
  }

  /* Keep the bar's size + price in step with the picker — it reads the same
     form, so it must never show a size the buyer did not choose. */
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('input[data-rh-opt]');
    if (!radio || !stickyBar) return;
    var form = radio.closest('[data-rh-atc-form], form.rh-atc-form');
    if (!form) return;
    var s = stickyBar.querySelector('[data-rh-sticky-size]');
    var pr = stickyBar.querySelector('[data-rh-sticky-price]');
    /* Show the full chosen combination — on a two-option product "Large" alone
       does not tell the buyer which colourway is in the bar. */
    if (s) s.textContent = chosenOpts(form).filter(Boolean).join(' / ');
    var v = matchVariant(form);
    if (pr && v) pr.textContent = money(v.price);
  });

  /* The drawer and the size-guide modal both own the bottom of the screen
     while open; the bar steps aside for them. */
  var _openDrawer = openDrawer, _closeDrawer = closeDrawer;
  openDrawer = function () { _openDrawer(); suppressSticky(true); };
  closeDrawer = function () { _closeDrawer(); suppressSticky(false); };
  var _openModal = openModal, _closeModal = closeModal;
  openModal = function (id) { _openModal(id); suppressSticky(true); };
  closeModal = function (m) { _closeModal(m); suppressSticky(false); };

  /* A "freeze the UI, we're navigating away" flag survives BFCache because the
     JS heap is restored on Back. Clear transient state on pageshow. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { pending = {}; getCart().then(renderCart); suppressSticky(false); }
  });

  /* The drawer is already server-rendered on first paint; this syncs the JS
     state to it so the first mutation is not computed from an empty object. */
  getCart().then(renderCart).catch(function () {});
})();
